<template>
<!--内容列表-->
  <div id="onLiveList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
            <input @keyup.enter="getList(1)" class="allInput" placeholder="文章标题" type="text" v-model="postData.Key">
          </p>

          <button @click="getList(1)" class="redButton">搜索</button>
          <button @click="newLive('new')" class="redButton">新建</button>
          
        </div>
        <div style="width: auto">
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <table cellspacing="0" class="allTable">
          <thead>
          <tr>
            <th>序号</th>
            <th>文章标题</th>
            <th>是否为轮播图</th>
            <th>是否置顶</th>
            <th>更新人</th>
            <th>更新时间</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="index" v-for="(item, index) in myList">
            <td>{{totalCount - ((index + 1) + (10 * (postData.PageIndex - 1))) + 1}}</td>
            <td>{{item.articleTitle}}</td>
            <td>{{item.isRotation ? '是' : '否'}}</td>
            <td>{{item.isTop ? '是' : '否'}}</td>
            <td>{{item.lastModifier}}</td>
            <td>{{item.lastModificationTime}}</td>

            <td width="11%"><div class="icon more iconfont icongengduo moreOperations">
              <ul>
                <!-- <li @click="newLive('edit', item)">编辑</li> -->
                <li @click="editLive(item, true)" v-if="!item.isTop">置顶</li>
                <li @click="editLive(item, false)" v-if="item.isTop">取消置顶</li>
                <!-- v-if="item.creatorId == userInfo.id" -->
                <li @click="delLive1(item)">删除</li>
              </ul>
            </div></td>
          </tr>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>

    <model v-if="isShowModel" :buttonType="0" :title="modeTitle" :maxHeight="'80vh'" :minWidth="'1000px'" v-on:on-cancel="cancelModel" v-on:on-confirm="confirModel">
      <div style="width:100%; box-sizing:border-box; padding:10px 40px;" class="font14">
        <div v-if="modelStep === 1">
          <div class="allSearch">
            <div class="newSearch d_flex">
              <div style="width: auto;white-space: normal">
                <p class="d_i">
                  <input @keyup.enter="getArticleList(1)" class="allInput" placeholder="标题" type="text" v-model="modelPostData.title">
                </p>
                <p class="d_i">
                  <input @keyup.enter="getArticleList(1)" class="allInput" placeholder="标签" type="text" v-model="modelPostData.tags">
                </p>
                <p class="d_i">
                  <abbr class="d_i">
                    <allSelect :chooseData="searchCate" :needReturn="'id'" :placeholder="'请选择内容分类'" :matchValue="'name'" :showValue="'{{productName}} | {{name}}'" v-model="modelPostData.categoryId">
                    </allSelect>
                  </abbr>
                </p>
                <button @click="getArticleList(1)" class="redButton d_i">搜索</button>
              </div>
              <div style="width: auto">
              </div>
            </div>
          </div>
           <div class="allTablePlace">
            <div style="max-height: 400px;overflow: auto">
              <table cellspacing="0" class="allTable alltableHui">
                <thead>
                <tr style="background-color: #FBFBFB;color: #797979">
                  <th></th>
                  <th>ID</th>
                  <th>文章名称</th>
                  <th class="t_c">文章类型</th>
                  <th class="t_c">标签</th>
                  <th class="t_c">分类</th>
                  <th class="t_c">创建人</th>
                </tr>
                </thead>
                <tbody>
                <tr @click="selectIndex = index" :class="selectIndex === index ? 'choosed' : ''" :key="index" v-for="(item, index) in modelList">
                  <td>
                  </td>
                  <td>{{item.id}}</td>
                  <td class="NoWrap" width="20%" style="max-width: 200px">{{item.title}}</td>
                  <td class="t_c NoWrap" width="10%">{{item.articleType == 'F' ? '武田推文' : '腾讯推文'}}</td>
                  <td class="t_c NoWrap" width="20%" style="max-width: 200px" >{{item.tags}}</td>
                  <td class="t_c">{{item.categoryName}}</td>
                  <td class="t_c">{{item.createName}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          <page v-if="modelTotalPage !== 0" :totalCount="modelTotalCount" v-on:on-getList="getArticleList($event)" :totalPage="modelTotalPage" :page="modelPage" :explain="0"></page>
        </div>
        </div>
        <div v-if="modelStep === 2">
          <div class="messagePushingStep font18">
            选择配置类型
          </div>
          <div style="display: flex;flex-direction: row;">
            <div class="t_c">
              <div class="t_c font16">设置为轮播图</div>
              <div class="m_t_10">
                <input v-model="modelData.isRotation" @change="isControl('isRotation')" :value="true" type="checkbox" class="allRadio" id="radioIsRotation" name="radio1"/>
                <label for="radioIsRotation"></label>
              </div>
              <div class="m_t_10">
                <label for="radioIsRotation">
                  <img src="../../../assets/articleManage/isRotate.png" class="d_i" style="width: 80%" alt="">
                </label>
              </div>
            </div>
            <div class="t_c">
              <div class="t_c font16">文章列表置顶</div>
              <div class="m_t_10">
                <input v-model="modelData.isTop" :value="true" @change="isControl('isTop')" type="checkbox" class="allRadio" id="radioIsTop" name="radio2"/>
                <label for="radioIsTop"></label>
              </div>
              <div class="m_t_10">
                <label for="radioIsTop">
                  <img src="../../../assets/articleManage/isTop.png" class="d_i" style="width: 80%" alt="">
                </label>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </model>
  </div>
</template>

<script>
export default {
  name: 'onLiveList',
  data () {
    return {
      brandList: [],
      token: window.sessionStorage.getItem('token'),
      baseUrl: process.env.config.baseUrl,
      nowApp: JSON.parse(window.sessionStorage.getItem('nowApp')),
      userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
      previewContentId: 0,
      doctorOpenId: '',
      addnewContentType: '',
      onSearch: false,
      newModel: false,
      tabSwitch: 1,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      postData: {
        Key: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize,
        countyInfo:"CountyCollection"
      },
      countyInfoList:[],
      modelPostData: {
        fromcollection: true,
        status: '2',
        articleType: 'F',
        title: '',
        tags: '',
        creator: '',
        categoryId: '',
        PageIndex: 1,
        PageSize: 5
      },
      modelPage: 1,
      myList: [],
      modelData: {
        id: 0,
        articleId: '',
        isRotation: true,
        isTop: true
      },
      modeTitle: '',
      isShowModel: false,
      modelStep: 1,
      fieldsListNew: [],
      fieldsList: [],
      indicationsListNew: [],
      indicationsList: [],
      modelTime: [],
      allcontent2: JSON.parse(window.localStorage.getItem('canEditList')) || [{id: 1, typeName: '测试类别'}],
      searchCate: [{
        id: '',
        name: '全部',
        productName: '全部'
      }],
      modelList: [],
      modelPage: 1,
      modelTotalPage: 0,
      modelTotalCount: 0,
      selectIndex: ''
    }
  },
  created () {
    console.log(this.userInfo, 'userInfo')
    // this.getconTypeList()
    // this.getconTypeList2()
    this.getCountyInfoList()
    this.getList(1)
    this.getFieldsList()
    this.getBrandList()
    this.getIndicationsList()
    this.searchCate = this.searchCate.concat(this.allcontent2)

  },
  methods: {
    // 获取县域信息
    getCountyInfoList () {
      this.$axiox.get(`/api/Article/GetAggregateRotateSearchList`).then(res => {
        this.countyInfoList = res
      })
      // this.countyInfoList=[{id:'False',name:'文章集锦'},{id:"True",name:'县域专区'}]
    },
    isControl(type){
      if (type === 'isRotation'){
        if (this.modelData.isRotation) {
          this.modelData.isTop = false
        }
      } else {
        if (this.modelData.isTop) {
          this.modelData.isRotation = false
        }
      }
    },
    cancelModel(){
      this.isShowModel = false
      this.getList(this.page)
    },
    getArticleList (pageIndex) {
      this.modelPostData.PageIndex = pageIndex
      let data = JSON.parse(JSON.stringify(this.modelPostData))
      data={
        ...data,
        countyInfo:"Country"
      }
      if (data.startdate === '') {
        delete data['startdate']
      }
      if (data.enddate === '') {
        delete data['enddate']
      }
      let url = this.$commonJs.returnQuery('/api/Article/QueryArticlewithCountInfo', data)
      this.$axiox.getList(url).then(msg => {
        console.log(msg)
        this.modelList = msg.data
        this.modelPage = pageIndex
        this.modelTotalPage = Math.ceil(msg.total / this.modelPostData.PageSize)
        this.modelTotalCount = msg.total
        this.selectIndex = ''
      })
      console.log(this.modelPostData)
    },
    timeChange(e){
      console.log(e)
      this.modelData.liveStartTime = this.getTime(e[0])
      this.modelData.liveEndTime = this.getTime(e[1])
      console.log(this.modelData)
    },
    getTime(time){
      let thisTime = time ? new Date(time) : new Date()
      let hour = thisTime.getHours()
      let min = thisTime.getMinutes()
      hour = hour < 10 ? '0' + hour : hour
      min = min < 10 ? '0' + min : min
      return `${hour}:${min}`
    },
    clopuploadImg (e) {
      // 上传图片
      var file = e.target.files[0]
      this.signalUpload(file)
    },
    async signalUpload (e) {
      let fileImg = e
      if (fileImg.type.indexOf('image') >= 0) {
        this.modelData.rotationUrl = await this.$commonJs.uploadFile(fileImg, '/api/Live/management/addthumb', 'formFile')
        document.getElementById('inFile').value = ''
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '只允许上传图片',
          stayTime: 5
        })
      }
    },
    changeField () {
      this.modelData.indications = ''
    },
    // 获取领域
    getFieldsList () {
      this.$axiox.get(`/api/Dict/GetFields`).then(res => {
        console.log(res, 'getFieldsList')
        this.fieldsListNew = JSON.parse(JSON.stringify(res))
        this.fieldsList = [
          {
            id: 0,
            name: '全部',
          },
          ...res
        ]
      })
    },
    // 获取适应症
    getIndicationsList (ids = []) {
      let params = ids
      this.$axiox.post(`/api/Dict/GetIndications`, params).then(res => {
        console.log(res, 'getIndicationsList')
        if (this.modelData.fields) {
          this.indicationsListNew = JSON.parse(JSON.stringify(res))
        } else {
          this.indicationsListNew = []
        }
        this.indicationsList = [
          {
            id: 0,
            fieldId: '',
            name: '全部',
          },
          ...res
        ]
      })
    },
    getBrandList(){
      this.$axiox.get('/api/Dict/Get/brands').then( p => {
        this.brandList = p || []
      } )
    },
    getMulBrand(e){
      this.modelData.brandCode = e
    },
    unShelve(item){
      this.$axiox.get(`/api/Article/recall?articleId=${item.id}`).then( p => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '下架成功',
          stayTime: 5
        })
        this.getList(1)
      } )
    },
    returnUrl (item) {
      return 'https://' + window.location.host + '/mobileContent?id=' + item.id + `&source=WY`
    },
    copyUrl (index) {
      let Url2 = document.getElementById('copyInpue' + index)
      Url2.select() // 选择对象
      document.execCommand('Copy')
    },
   getCanOn(){

   },
   setCarousel(item){
     this.newLive('edit', item)
    //  debugger
    // if (item.isRotation) {
    //   this.$axiox.get('/api/Live/management/LiveRotationIsOver').then( msg => {
    //     if (msg){
    //       this.$axiox.post(`/api/Live/management/update`, item).then( p => {
    //         this.$commonJs.alertTips({
    //           type: 'success',
    //           title: '成功',
    //           content: title,
    //           stayTime: 5
    //         })
    //         this.getList(this.page)
    //       } )
    //     } else{
    //       this.$commonJs.alertTips({
    //         type: 'error',
    //         title: '错误',
    //         content: '轮播设置已达上限',
    //         stayTime: 5
    //       })
    //     }
    //   } )
    // } else {
    //   this.$axiox.post(`/api/Live/management/update`, item).then( p => {
    //     this.$commonJs.alertTips({
    //       type: 'success',
    //       title: '成功',
    //       content: title,
    //       stayTime: 5
    //     })
    //     this.getList(this.page)
    //   })
    // }
   },
   editLive(item, status){
     let data = {
      "id": item.id,
      "articleId": item.articleId,
      "isRotation": item.isRotation,
      "isTop": status,
      "action": "Update"
     }
      let title = status ? '置顶成功!' : '取消置顶成功!'
      this.$axiox.post('/api/ArticleCollectionManagement/AddOrUpdateOrDel',  data).then( p => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: title,
          stayTime: 5
        })
        this.isShowModel = false
        this.getList(1)
      } )
   },
   delLive1(item){
     let data= {
      "id": item.id,
      "articleId": item.articleId,
      "isRotation": item.isRotation,
      "isTop": item.isTop,
      "action": "Delete"
     }
      this.$commonJs.doubleComfirm({
        content: '是否确定删除此配置？',
        successFun: msg => {
          this.$axiox.post('/api/ArticleCollectionManagement/AddOrUpdateOrDel', data).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getList(this.page)
          })
        },
        errorFun: msg => {
        }
      })
   },
    delLive (item) {
      this.$commonJs.doubleComfirm({
        content: '是否确定删除此配置？',
        successFun: msg => {
          this.$axiox.get('/api/ArticleCollectionManagement/del/' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getList(this.page)
          })
        },
        errorFun: msg => {
        }
      })
    },
    openOrClose(item){
      this.$axiox.get('/api/Live/management/switch/' + item.id).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '操作成功',
          stayTime: 5
        })
        this.getList(this.page)
      })
    },
    newLive(method, item){
      if(method === 'new'){
        this.modeTitle = '选择文章'
        this.selectIndex = ''
        this.modelData = {
          id: 0,
          articleId: '',
          isRotation: false,
          isTop: false
        }
        this.modelPostData = {
          fromcollection: true,
          status: '2',
          title: '',
          articleType: 'F',
          tags: '',
          creator: '',
          categoryId: '',
          PageIndex: 1,
          PageSize: 5
        }
        this.modelTime = [new Date() , new Date()]
        this.isShowModel = true
        this.modelStep = 1
        this.getArticleList(1)
      } else if(method === 'edit'){
        this.modeTitle = '编辑配置'
        this.$axiox.get(`/api/ArticleCollectionManagement/detail/${item.id}`).then( p => {
          this.modelData = p
          this.isShowModel = true
          this.modelStep = 2
        } )
      }
    },
    cencelPreview () {
      this.coverShow = false
    },
    // 切换搜索条件
    tewoSearch () {
      this.onSearch = !this.onSearch
    },
    // 新建
    editToUrl () {
      this.newModel = true
    },
    getList (pageIndex) {
      this.postData.PageIndex = pageIndex
      let data = JSON.parse(JSON.stringify(this.postData))
      if (data.startdate === '') {
        delete data['startdate']
      }
      if (data.enddate === '') {
        delete data['enddate']
      }
      let url = this.$commonJs.returnQuery('/api/ArticleCollectionManagement/list', data)
      this.$axiox.getList(url).then(msg => {
        console.log(msg)
        this.myList = msg.data
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
      console.log(this.postData)
    },
    editList (item) {
      this.$router.push({
        name: 'editContList',
        query: {
          id: item.id,
          fromType: 'draft',
          selectContentType: 0,
          selectContentName: item.contentType
        }
      })
    },
    confirModel () {
      // if (this.modelStep === 1){
        if (this.selectIndex || this.selectIndex  === 0){
          // this.modelStep = 2
          // this.modeTitle = '新建配置'
          console.log(this.modelList[this.selectIndex])
          let data = {
            articleId: this.modelList[this.selectIndex].id,
            isRotation: true,
            isTop: false,
            action: "Add",      // Add, Update, Delete
            collectFrom:"CountyCollection"
          }
          this.$axiox.post('/api/ArticleCollectionManagement/AddOrUpdateOrDel',  data).then( p => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '新增成功！',
              stayTime: 5
            })
            this.isShowModel = false
            this.getList(1)
          } )
        } else {
          return this.$commonJs.alertTips({
            type: 'error',
            title: '错误',
            content: '请选择操作文章！',
            stayTime: 5
          })
        }
      // } else {
      //   let url = '', title = ''
      //   if (this.modeTitle === '新建配置'){
      //     this.modelData.articleId = this.modelList[this.selectIndex].id
      //     console.log(this.modelData)
      //     url = '/api/ArticleCollectionManagement/add'
      //     title = '新增成功！'
      //   } else {
      //     delete this.modelData.lastModificationTime
      //     delete this.modelData.lastModifier
      //     delete this.modelData.lastModifierId
      //     url = '/api/ArticleCollectionManagement/update'
      //     title = '编辑成功！'
      //   }
      //   this.$axiox.post(url, this.modelData).then( p => {
      //     this.$commonJs.alertTips({
      //       type: 'success',
      //       title: '成功',
      //       content: title,
      //       stayTime: 5
      //     })
      //     this.isShowModel = false
      //     this.getList(1)
      //   } )
      // }
    }
  },
  watch: {
    "postData.countyInfo" (newData) {
      if (newData) {
        this.getList(1)
      } else {
        
      }
    },
    "modelData.fields" (newData) {
      console.log(newData, 'modelData.fields')
      if (newData) {
        let ids = (newData.split(',')).map(val => Number(val))
        console.log(ids, 'ids')
        this.getIndicationsList(ids)
      } else {
        this.indicationsListNew = []
      }
    },
  },
  components: {
  }
}
</script>

<style scoped>
.forElClass >>> .el-date-editor.el-range-editor{
  width: 100%
}
.forElClass >>> .el-date-editor.el-range-editor.is-active{
  background-color: #fff;
}
.forElClass >>> .el-range-editor.is-active, .forElClass >>> .el-range-editor.is-active:hover {
  border-color: #DEDEDE;
}
tr.choosed td{
  background: #FF7F41;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/articleManage/takedaCountyManage.vue